module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators-1-w960.5807d7b1.webp";